<mat-checkbox
  [ngModel]="checked()"
  (ngModelChange)="onCheckedChange($event)"
  [disabled]="isDisabled()"
  color="primary"
  [id]="id() ?? ''"
  [tabIndex]="tabDisabled() ? '-1' : '0'"
  class="sia-inputs-full sia-input"
>
</mat-checkbox>
<label
  (click)="changeValue()"
  [class]="
    isDisabled()
      ? 'sia-input sia-inputs-full sia-inputs-full--disabled'
      : 'sia-input sia-inputs-full'
  "
>
  {{ label() | siaTranslate }}
</label>
